export default function searchInPropsHelper(obj, props, value) {
    let finded = false;
    props.forEach((prop) => {
        if (obj.hasOwnProperty(prop) && obj[prop] && obj[prop].toLowerCase().includes(value.toLowerCase())) {
            finded = true;
            return;
        }
    })
    return finded;
}